import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import AppAppBar from '../components/AppAppBar';
import AppTheme from '../AppTheme';

export default function DeclarationPage(props) {
  // 手寫體字體堆疊：先用你已有的 LXGW，再備援幾款常見中文手寫體，最後回退 cursive
  const handwriting = `"LXGW WenKai TC","LXGW WenKai Mono TC","Ma Shan Zheng","ZCOOL KuaiLe","Sawarabi Mincho","STKaiti","KaiTi","DFKai-SB",cursive`;

    // 學術風格背景
  const backgroundSx = {
    position: "fixed",     // 固定在螢幕
    top: 0,
    left: 0,
    width: "100vw",        // 全螢幕寬
    height: "100vh",       // 全螢幕高
    zIndex: -1,            // 放在最底層，避免遮擋內容
    backgroundColor: '#f6f4ea',
    backgroundImage: `
      radial-gradient(1000px 600px at 20% -10%, rgba(255,255,255,0.7), rgba(255,255,255,0) 60%),
      radial-gradient(900px 500px at 120% 0%, rgba(255,255,255,0.55), rgba(255,255,255,0) 65%),
      linear-gradient(180deg, rgba(0,0,0,0.03) 1px, transparent 1px),
      linear-gradient(90deg, rgba(0,0,0,0.03) 1px, transparent 1px)
    `,
    backgroundSize: `
      auto,
      auto,
      100% 28px,
      28px 100%
    `,
  };  
  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />
      <AppAppBar />

      {/* 整頁黃紙紋理背景 */}
      <Box sx={{mt:16, position: "relative" }}>
        <Box sx={backgroundSx} />   {/* 背景層 */}

        {/* 中央宣言框（半透明紙面，帶邊框與陰影） */}
        <Container
          maxWidth="md"
          sx={{
            bgcolor: 'rgba(255, 249, 205, 0.7)', // 稍淺的黃紙疊色
            border: '1px solid rgba(120, 90, 20, 0.25)',
            boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
            borderRadius: '20px',
            backdropFilter: 'blur(1.5px)',
            p: { xs: 4, md: 6 },
            textAlign: 'center',
          }}
        >
          {/* 「網站聲明」四字 */}
          <Typography
            component="h1"
            sx={{
              fontFamily: handwriting,
              fontSize: { xs: '2.6rem', sm: '3.2rem', md: '3.8rem' },
              letterSpacing: '0.15em',
              fontWeight: 700,
              color: '#3a2b14',
              textShadow:
                '0 1px 0 rgba(255,255,255,0.6), 0 3px 6px rgba(0,0,0,0.18)',
              mb: { xs: 3, md: 4 },
              userSelect: 'none',
            }}
          >
            網站聲明
          </Typography>

          {/* 分隔線（毛筆感） */}
          <Box
            sx={{
              mx: 'auto',
              width: { xs: '70%', md: '60%' },
              height: '2px',
              background:
                'linear-gradient(90deg, rgba(58,43,20,0), rgba(58,43,20,0.6), rgba(58,43,20,0))',
              filter: 'blur(0.2px)',
              mb: { xs: 3, md: 4 },
            }}
          />

          {/* 內容文字（手寫體、行高舒適） */}
          <Box
            sx={{
              display: 'grid',
              gap: 2,
              justifyItems: 'center',
              color: '#3a2b14',
            }}
          >
            <Typography
              sx={{
                fontFamily: handwriting,
                fontSize: { xs: '1.25rem', md: '1.45rem' },
                lineHeight: 1.9,
                textShadow: '0 1px 0 rgba(255,255,255,0.4)',
              }}
            >
              本網站所有信息不構成投資建議！
            </Typography>
            <Typography
              sx={{
                fontFamily: handwriting,
                fontSize: { xs: '1.25rem', md: '1.45rem' },
                lineHeight: 1.9,
                textShadow: '0 1px 0 rgba(255,255,255,0.4)',
              }}
            >
              本網站高度重視用戶隱私和言論自由，但嚴禁廣告和洗版！
            </Typography>
            <Typography
              sx={{
                fontFamily: handwriting,
                fontSize: { xs: '1.25rem', md: '1.45rem' },
                lineHeight: 1.9,
                textShadow: '0 1px 0 rgba(255,255,255,0.4)',
              }}
            >
              嚴禁泄露他人（獨裁者除外）隱私，同時也不要泄露自己的個人信息！
            </Typography>
            <Typography
              sx={{
                fontFamily: handwriting,
                fontSize: { xs: '1.25rem', md: '1.45rem' },
                lineHeight: 1.9,
                textShadow: '0 1px 0 rgba(255,255,255,0.4)',
              }}
            >
              請保持活躍，超過180天未登陸的用戶會被系統自動刪除！
            </Typography>
            {/* 下方再來一條分隔線，加強儀式感 */}
            <Box
              sx={{
                mx: 'auto',
                width: { xs: '60%', md: '50%' },
                height: '2px',
                background:
                  'linear-gradient(90deg, rgba(58,43,20,0), rgba(58,43,20,0.6), rgba(58,43,20,0))',
                filter: 'blur(0.2px)',
                my: { xs: 2, md: 3 },
              }}
            />

            <Typography
              sx={{
                fontFamily: handwriting,
                fontSize: { xs: '1.35rem', md: '1.6rem' },
                lineHeight: 2,
                fontWeight: 700,
                letterSpacing: '0.08em',
                textShadow:
                  '0 1px 0 rgba(255,255,255,0.55), 0 2px 6px rgba(0,0,0,0.15)',
              }}
            >
              一切榮耀歸上帝！
            </Typography>
          </Box>
        </Container>
      </Box>
    </AppTheme>
  );
}
